import React from 'react';
import { TableFilter, TableFilterItem } from 'components/TableFilter';

import Preloader from 'components/Preloader';
import EmptyContent from 'components/EmptyContent';
import SelectElement from 'components/AtomicStructure/atoms/SelectElement';

import {
    Table,
    SearchBar,
    Button,
} from 'ui-library';
import { getColumns } from '../../table/table';
import { DEFAULT_PAGE_SIZE } from '../../constants/const';

const GeneralDocuments = ({
    t,
    productOptions,
    productId,
    setProductId,
    searchTerm,
    setSearchTerm,
    filteredData,
    isLoading,
    docError,
    currentPagination,
    tableData,
    onChangePage,
    hasAccessPolicy,
    setShowModal,
}) => (
    <div>
        <TableFilter>
            <TableFilterItem>
                <SelectElement
                    placeholder={t('advisoryDashboard.documents.product')}
                    options={productOptions}
                    value={productId}
                    onChange={setProductId}
                />
            </TableFilterItem>
            <TableFilterItem>
                <SearchBar
                    onSearch={(value: string) => setSearchTerm(value)}
                    value={searchTerm}
                    className="search-wrapper"
                    placeholder={t('clientDashboard.documents.search')}
                />
            </TableFilterItem>
            {hasAccessPolicy('UploadGeneralDocuments') ? (
                <TableFilterItem className="ml-auto">
                    <Button
                        type="secondary"
                        size="small"
                        className="doc-library__upload-btn"
                        onClick={() => setShowModal(true)}
                    >
                        {t('advisoryDashboard.documents.uploadDocument')}
                    </Button>
                </TableFilterItem>
            ) : undefined}
        </TableFilter>
        <Preloader isLoading={isLoading} error={docError}>
            <EmptyContent
                data={filteredData}
                text={t('advisoryDashboard.documents.noDocuments')}
            >
                <Table
                    columns={getColumns(t)}
                    data={tableData}
                    paging={{
                        total: filteredData.length,
                        pageSize: DEFAULT_PAGE_SIZE,
                        currentPage: currentPagination,
                    }}
                    onChange={onChangePage}
                />
            </EmptyContent>
        </Preloader>
    </div>
);

export default GeneralDocuments;
